import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'locationType',
    standalone: false
})
export class LocationTypePipe implements PipeTransform {
    transform(locationType?: 'branch' | 'remote' | 'hqFallback'): string {
        if (locationType === 'branch') {
            return 'Branch';
        } else if (locationType === 'remote') {
            return 'Remote';
        } else if (locationType === 'hqFallback' || locationType === undefined) {
            return 'Default HQ';
        } else {
            return 'HQ';
        }
    }
}
